import { useEffect, useState } from "react";

export function useIsDesktop() {
  const [d, setD] = useState(() => typeof window !== "undefined" && window.innerWidth >= 1024);
  useEffect(() => {
    const on = () => setD(window.innerWidth >= 1024);
    window.addEventListener("resize", on);
    return () => window.removeEventListener("resize", on);
  }, []);
  return d;
}

export function useIsWide() {
  const [d, setD] = useState(() => typeof window !== "undefined" && window.innerWidth >= 768);
  useEffect(() => {
    const on = () => setD(window.innerWidth >= 768);
    window.addEventListener("resize", on);
    return () => window.removeEventListener("resize", on);
  }, []);
  return d;
}
